import TMain from '../templates/main';
import useSection from '@shared/components/utils/hooks/useSection';
import { QuerySections } from '@shared/types/enums/sections';

/**
 * Movies page component that displays movies content with highlights and reels.
 * Starts navigation in menu
 */
export default function Movies() {
  const { complete, highlights, reels, onPagination } = useSection({
    section: QuerySections.MOVIES,
  });

  return (
    <TMain
      complete={complete}
      rails={reels}
      sliders={highlights}
      hideBackground={true}
      startsInMenu
      startsInSlider
      onPagination={onPagination}
    />
  );
}
